<template>
    <div>
        <Nuxt />
    </div>
</template>
<script>
export default {
   name: 'Default'
}
</script>